module.exports = __webpack_public_path__ + "media/react/features/overview/suggestions/icons/miro-icon-169004256996773bb9f2d7cac6fdcc51.png";